export const DOWNLOAD_PRINT_SETTING_NAME = 'download';
export const PREVIEW_PRINT_SETTING_NAME = 'preview';
export const ALWAYS_PROMPT_PRINT_SETTING_NAME = 'always prompt';
export const SHOW_PACKING_SLIP_REPRINT_WARNING_KEY = 'show-packing-slip-reprint-warning';
